<template>
  <div class="laddercontroldescribe">
    <div class="header">
      <div class="title">智能梯控硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="LaddercontrolDescribeLogo" alt="" />
      </div>

      <div class="right">
        <div class="title">基本功能</div>
        <div class="text">
          自动识别，防止陌生人员非法使用电梯,控制器一旦有硬件和软件故障，可立即使电梯自动恢复为自由状态，可按选层钮乘梯与电梯的消防紧急开关实现联动的功能，独特的内嵌式密码键盘，住户可自行修改密码，无须管理人员参与，减少繁琐的管理工作，增加安全性。
        </div>

        <div class="list">
          <div
            class="item"
            v-for="item in laddercontroldescribeList"
            :key="item.id"
          >
            <div class="it-title">{{ item.title }}</div>
            <div class="it-list">
              <div class="it-item" v-for="it in item.list" :key="it.id">
                <img :src="it.logo" alt="" />
                <div>{{ it.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import LaddercontrolDescribeLogo from "../../../../assets/programme/LaddercontrolDescribeLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      LaddercontrolDescribeLogo: LaddercontrolDescribeLogo,
      laddercontroldescribeList: [
        {
          id: 1,
          title: "管理功能",
          list: [
            {
              id: 1,
              logo: yesLogo,
              title: "系统管理",
            },
            {
              id: 2,
              logo: yesLogo,
              title: "权限设置",
            },
            {
              id: 3,
              logo: yesLogo,
              title: "时段设置",
            },
            {
              id: 4,
              logo: yesLogo,
              title: "自动识别管理",
            },
          ],
        },
        {
          id: 2,
          title: "扩展功能",
          list: [
            {
              id: 1,
              logo: yesLogo,
              title: "支持消防联动",
            },
            {
              id: 2,
              logo: yesLogo,
              title: "支持楼宇对讲",
            },
          ],
        },
      ],
    });
  },
};
</script>

<style scoped>
.laddercontroldescribe {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.body .left img {
  width: 600px;
}
.body .right {
  width: 500px;
}
.body .right .title {
  font-size: 16px;
  color: #333;
}
.body .right .text {
  font-size: 14px;
  margin-top: 20px;
  color: #3d3d3d;
}

.body .right .list .item {
  margin-top: 40px;
}
.body .right .list .item .it-title {
  font-size: 16px;
  color: #333;
}
.body .right .list .item .it-list {
    display: flex;
    margin-top: 20px;
}
.body .right .list .item .it-list .it-item {
  display: flex;
  align-items: center;
  margin-right: 25px;
}
.body .right .list .item .it-list .it-item img {
    width: 18px;
    margin-right: 10px;
}
</style>
